import React, { useEffect, useState } from "react"
import { BackHandler, TouchableOpacity, View, useWindowDimensions } from "react-native"
import DraggableFlatList, { ScaleDecorator } from "react-native-draggable-flatlist"
import { Icon, ThemeConsumer } from "@rneui/themed"
import { appColors, appFonts, fontSize } from "../../../themes/appTheme"
import { RouteProp, useIsFocused, useNavigation, useRoute } from "@react-navigation/native"
import CommonHeader from "../../../shared/commonComponents/commonHeader"
import { config } from "../../../shared/environment"
import Toast from "react-native-toast-message"
import { SortRouteType, SortOptionUpdatedValueType } from "./optionModule"
import { DialogBoxType } from "../../giftCard/giftCardModule"
import Popover from "react-native-popover-view/dist/Popover"
import CommonDialogBox from "../../../shared/commonComponents/commonDialogBox"
import { useAppDispatch } from "../../../redux/hooks"
import { getAllPosOptionList, getAllSortOptionData, getOneSortOptionData } from "../../../redux/slices/optionSlice"
import { ZenLoader } from "zen-core-elements"
import ZenText from "zen-core-elements/src/elements/zenText/zenText"
import { CustomModal } from "../../../shared/commonComponents/customModal"

let trigger = false

const SortOptionList = () => {
    const dispatch = useAppDispatch()
    const isFocus = useIsFocused()
    const dimensions = useWindowDimensions()
    const isTablet = dimensions.width > 700

    const [isLoading, setIsLoading] = useState(false)
    const props: RouteProp<SortRouteType, 'SortOptionList'> = useRoute()
    const navigation = useNavigation()

    const [sortData, setSortData] = useState<SortOptionUpdatedValueType[]>([])
    const [dialogPop, setDialogPop] = useState(false)
    const [dialogData, setDialogData] = useState<DialogBoxType | null>(null)
    const [isAnyChanges, setChanges] = useState(0)

    useEffect(() => {
        if (props.params?.sortOptionValue && isFocus) {
            trigger = false
            setSortData([])
            if (props.params?.isList) {
                setIsLoading(true)
                dispatch(getAllPosOptionList({ storeId: config.storeId, data: '' })).unwrap().then((res) => {
                    if (res) {
                        setSortData(res?.options?.rows || [])
                        setIsLoading(false)
                    }
                })
                    .catch((err: any) => {
                        setIsLoading(false)
                        console.log("err in getPosOptionList", err)
                    })
            } else {
                setSortData(props?.params?.sortOptionValue || [])
            }
            setChanges(0)
            setTimeout(() => {
                trigger = true
            }, 500)
        }
    }, [isFocus])

    useEffect(() => {
        if (dialogPop && dialogData != null) {
            if (dialogData.id === 2) {
                navigation.goBack()
                setSortData([])
            } else {
                setDialogPop(false)
            }
        }
    }, [dialogData])

    const sortOptionDataValues = () => {
        if (props.params?.isList) {
            setIsLoading(true)
            let sortedData: { id: number, sortOrder: number }[] = []
            sortData.forEach((i, index) => sortedData.push({ id: i.id, sortOrder: index + 1 }))
            if (sortedData.length) {
                let data = { optionData: sortedData }
                dispatch(getAllSortOptionData({ storeId: config.storeId, data: data })).unwrap().then((res) => {
                    setIsLoading(false)
                    if (res.success) {
                        Toast.show({
                            type: 'success',
                            text2: 'Option list sorted successfully'
                        })
                        navigation.goBack()
                    }
                })
                    .catch((err: any) => {
                        setIsLoading(false)
                        console.log("error in getAllSortOptionData", err)
                    })
            }
        } else {
            let sortedData: { optionValue: string | undefined, optionValueId: number, sortOrder: number }[] = []
            sortData.forEach((i, index) => sortedData.push({ optionValue: i?.optionValue, optionValueId: i.id, sortOrder: index + 1 }))
            if (sortData.length) {
                let data = { optionValueData: sortedData }
                dispatch(getOneSortOptionData({ storeId: config.storeId, updateId: props.params?.selectedId, data: data })).unwrap().then((res) => {
                    setIsLoading(false)
                    if (res?.success) {
                        Toast.show({
                            type: 'success',
                            text2: 'Option values sorted successfully'
                        })
                        navigation.goBack()
                    }
                })
                    .catch((err: any) => {
                        setIsLoading(false)
                        console.log("error in getOneSortOptionData", err)
                    })
            }
        }
        setDialogData(null)
    }

    useEffect(() => {
        if (trigger && sortData.length) {
            setChanges((prev) => prev + 1)
        }
    }, [sortData])

    const handleBack = () => {
        if (isAnyChanges > 0) {
            setDialogPop(true)
        } else {
            navigation.goBack()
            setSortData([])
        }
    }

    useEffect(() => {
        const backHandler = BackHandler.addEventListener('hardwareBackPress', function () {
            handleBack()
            return true
        })
        return () => backHandler.remove()
    }, [isAnyChanges])

    return (
        <ThemeConsumer>
            {({ theme }) => (
                <View style={theme.sortOptionListStyle.parent}>
                    {/* CommonHeader with clear, unclipped action buttons */}
                    <CommonHeader
                        headerName={props.params?.isList ? "Sort Options" : "Sort Option Values"}
                        backIcon
                        backIconOnpress={handleBack}
                        rightComponent={
                            <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10, paddingRight: 4 }}>
                                <TouchableOpacity
                                    onPress={handleBack}
                                    activeOpacity={0.7}
                                    style={{
                                        backgroundColor: '#F1F5F9',
                                        borderWidth: 1,
                                        borderColor: '#CBD5E1',
                                        borderRadius: 8,
                                        paddingHorizontal: 16,
                                        paddingVertical: 8,
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}
                                >
                                    <ZenText
                                        content="Cancel"
                                        bold
                                        size={fontSize.smallFontSize}
                                        color="#475569"
                                    />
                                </TouchableOpacity>

                                <TouchableOpacity
                                    disabled={!isAnyChanges}
                                    activeOpacity={0.8}
                                    onPress={() => {
                                        if (isAnyChanges) {
                                            sortOptionDataValues()
                                        } else {
                                            Toast.show({
                                                type: 'info',
                                                text2: 'You have no unsaved changes'
                                            })
                                        }
                                    }}
                                    style={{
                                        backgroundColor: isAnyChanges ? appColors.primary : '#94A3B8',
                                        borderRadius: 8,
                                        paddingHorizontal: 18,
                                        paddingVertical: 8,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        opacity: isAnyChanges ? 1 : 0.7
                                    }}
                                >
                                    <ZenText
                                        content="Save Order"
                                        bold
                                        size={fontSize.smallFontSize}
                                        color={appColors.light}
                                    />
                                </TouchableOpacity>
                            </View>
                        }
                    />

                    {/* Main content table card */}
                    <View style={{ flex: 1, padding: isTablet ? 18 : 12 }}>
                        <View style={theme.sortOptionListStyle.cardWrapper}>
                            {/* Card Header */}
                            <View style={theme.sortOptionListStyle.cardHeader}>
                                <View style={{ flexDirection: 'row', alignItems: 'center', flex: 1, marginRight: 12 }}>
                                    <View style={theme.sortOptionListStyle.infoIconCircle}>
                                        <Icon name="swap-vertical" type="material-community" size={22} color={appColors.primary} />
                                    </View>
                                    <View style={{ flex: 1 }}>
                                        <ZenText
                                            content={props.params?.isList ? "Option Display Order" : "Option Value Order"}
                                            bold
                                            size={16}
                                            color="#1E293B"
                                        />
                                        <ZenText
                                            content="Drag and drop items using the grip handle (⠿) to rearrange display order"
                                            size={12}
                                            color="#64748B"
                                            style={{ marginTop: 2 }}
                                        />
                                    </View>
                                </View>
                                <View
                                    style={{
                                        backgroundColor: '#F1F5F9',
                                        paddingHorizontal: 12,
                                        paddingVertical: 4,
                                        borderRadius: 12,
                                        borderWidth: 1,
                                        borderColor: '#CBD5E1'
                                    }}
                                >
                                    <ZenText
                                        content={`${sortData.length} ${sortData.length === 1 ? 'item' : 'items'}`}
                                        bold
                                        size={12}
                                        color="#475569"
                                    />
                                </View>
                            </View>

                            {/* Draggable FlatList */}
                            <DraggableFlatList
                                data={sortData}
                                keyExtractor={(item, index) => (item?.id ? String(item.id) : index.toString())}
                                ListEmptyComponent={
                                    !isLoading ? (
                                        <View style={{ padding: 40, alignItems: 'center', justifyContent: 'center' }}>
                                            <Icon name="format-list-bulleted" type="material-community" size={48} color="#94A3B8" />
                                            <ZenText
                                                content="No items available to sort"
                                                size={14}
                                                color="#64748B"
                                                bold
                                                style={{ marginTop: 12 }}
                                            />
                                        </View>
                                    ) : null
                                }
                                renderItem={({ item, isActive, drag, getIndex }) => {
                                    const currentIndex = (getIndex ? getIndex() : 0) ?? 0
                                    const itemLabel = item?.optionValue || item?.name || ''
                                    const itemMedium = item?.meduim || (item as any)?.medium

                                    return (
                                        <ScaleDecorator activeScale={1.01}>
                                            <View
                                                key={currentIndex}
                                                style={[
                                                    theme.sortOptionListStyle.itemCon,
                                                    isActive && theme.sortOptionListStyle.itemConActive
                                                ]}
                                            >
                                                {/* Left Section: Grip Handle + Rank + Color Chip + Name + Tag */}
                                                <View style={{ flexDirection: 'row', alignItems: 'center', flex: 1, marginRight: 16 }}>
                                                    {/* Left Grip Handle */}
                                                    <TouchableOpacity
                                                        onPressIn={drag}
                                                        hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
                                                        style={[
                                                            theme.sortOptionListStyle.dragHandle,
                                                            { marginRight: 12 },
                                                            isActive && { backgroundColor: '#DBEAFE', borderColor: '#93C5FD' }
                                                        ]}
                                                    >
                                                        <Icon
                                                            name="drag-vertical"
                                                            type="material-community"
                                                            size={22}
                                                            color={isActive ? appColors.primary : "#64748B"}
                                                        />
                                                    </TouchableOpacity>

                                                    {/* Rank Number Badge */}
                                                    <View
                                                        style={[
                                                            theme.sortOptionListStyle.indexBadge,
                                                            { marginRight: 12 },
                                                            isActive && { backgroundColor: '#DBEAFE' }
                                                        ]}
                                                    >
                                                        <ZenText
                                                            content={`#${currentIndex + 1}`}
                                                            size={11}
                                                            bold
                                                            color={isActive ? appColors.primary : "#64748B"}
                                                        />
                                                    </View>

                                                    {/* Color chip preview if option value has color */}
                                                    {item?.color && (
                                                        <View
                                                            style={{
                                                                width: 22,
                                                                height: 22,
                                                                borderRadius: 11,
                                                                backgroundColor: item.color,
                                                                borderWidth: 1.5,
                                                                borderColor: '#CBD5E1',
                                                                marginRight: 10
                                                            }}
                                                        />
                                                    )}

                                                    {/* Title & Metadata */}
                                                    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                                                        <ZenText
                                                            content={itemLabel}
                                                            size={15}
                                                            bold
                                                            color={isActive ? appColors.primary : "#1E293B"}
                                                        />
                                                        {item?.color && (
                                                            <ZenText
                                                                content={item.color.toUpperCase()}
                                                                size={12}
                                                                color="#64748B"
                                                            />
                                                        )}
                                                        {itemMedium && (
                                                            <View
                                                                style={{
                                                                    backgroundColor: itemMedium === 'POS' ? '#E0F2FE' : '#FEF3C7',
                                                                    paddingHorizontal: 8,
                                                                    paddingVertical: 2,
                                                                    borderRadius: 6
                                                                }}
                                                            >
                                                                <ZenText
                                                                    content={itemMedium}
                                                                    size={11}
                                                                    bold
                                                                    color={itemMedium === 'POS' ? appColors.primary : '#B45309'}
                                                                />
                                                            </View>
                                                        )}
                                                    </View>
                                                </View>

                                                {/* Right Section: Subtle Drag Hint */}
                                                <TouchableOpacity
                                                    onPressIn={drag}
                                                    hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
                                                    style={{ flexDirection: 'row', alignItems: 'center', gap: 4, padding: 6 }}
                                                >
                                                    <ZenText content="Drag to move" size={12} color="#94A3B8" />
                                                    <Icon name="reorder-horizontal" type="material-community" size={18} color="#94A3B8" />
                                                </TouchableOpacity>
                                            </View>
                                        </ScaleDecorator>
                                    )
                                }}
                                containerStyle={{ flex: 1 }}
                                contentContainerStyle={{
                                    flexGrow: 1,
                                    paddingBottom: 40
                                }}
                                showsVerticalScrollIndicator={false}
                                onDragEnd={({ data }) => {
                                    setSortData(data)
                                }}
                            />
                        </View>
                    </View>

                    {/* Full-screen Loading Modal */}
                    <CustomModal visible={isLoading} transparent={true}>
                        <View style={theme.sortOptionListStyle.loadCon}>
                            <ZenLoader lottieType="Local" lottie={require("../../../assets/infinityLoader.json")} />
                        </View>
                    </CustomModal>

                    {/* Unsaved Changes Confirmation Dialog */}
                    <Popover isVisible={dialogPop}>
                        <CommonDialogBox type="EDIT" replaceValue="sort option" confirmation={setDialogData} />
                    </Popover>
                </View>
            )}
        </ThemeConsumer>
    )
}

export default SortOptionList